export const boardData = [
  {
    key: '',
    col1: '1',
    col2: '1148',
    col3: '1',
    col4: '230530001',
    col5: '제목1',
    col6: '2',
    col7: '본사',
    col8: '2023-00-00 00:00:00',
    col9: '194',
  }, {
    key: '2',
    col1: '0',
    col2: '1147',
    col3: '1',
    col4: '230530002',
    col5: '제에에에에목',
    col6: '1',
    col7: 'IT팀',
    col8: '2023-00-00 00:00:00',
    col9: '194',
  }, {
    key: '3',
    col1: '0',
    col2: '1146',
    col3: '2',
    col4: '230530003',
    col5: '제목제목제목',
    col6: '0',
    col7: '교육연구소',
    col8: '2023-00-00 00:00:00',
    col9: '194',
  }, {
    key: '4',
    col1: '0',
    col2: '1146',
    col3: '2',
    col4: '230530003',
    col5: '제제제목목목',
    col6: '0',
    col7: '교육연구소',
    col8: '2023-00-00 00:00:00',
    col9: '194',
  }, {
    key: '5',
    col1: '0',
    col2: '1146',
    col3: '3',
    col4: '230530003',
    col5: '목제',
    col6: '0',
    col7: '교육연구소',
    col8: '2023-00-00 00:00:00',
    col9: '194',
  }, {
    key: '6',
    col1: '0',
    col2: '1146',
    col3: '3',
    col4: '230530003',
    col5: '자료1',
    col6: '0',
    col7: '교육연구소',
    col8: '2023-00-00 00:00:00',
    col9: '194',
  }, 
]

export const boardWorkDetilData = [
  {
    key: '',
    col1: '작성자 | 서울 은평증산점',
    col2: '등록일 | 2023-00-00',
    col3: '문서번호 | 938040',
    col4: '조회수 | 11'
  }
]

export const branchTreeData = [
  {
        title: '베이직',
        key: '10',
        children: [
          { title: '1호', key: '1001',
            children: [
              { title: '한글', key: '1001-1' },
              { title: '수학', key: '1001-2' },
              { title: '칠교', key: '1001-3' },
            ]
          },
          { title: '2호', key: '1002',
            
          },
          { title: '3호', key: '1003',
            
          },
          { title: '4호', key: '1004',
            
          },
          { title: '5호', key: '1005' },
          { title: '6호', key: '1006' },
          { title: '7호', key: '1007' },
          { title: '8호', key: '1008' },
          { title: '9호', key: '1009' },
          { title: '10호', key: '1010' },
          { title: '11호', key: '1011' },
          { title: '12호', key: '1012', isLeaf: true },
        ]
      }, {
        title: '그로우',
        key: '20',
        children: [
          { title: '한글', key: '2001', isLeaf: true },
          { title: '수학', key: '2002', isLeaf: true },
          { title: '칠교', key: '2003' },
          { title: '한자', key: '2004' },
        ]
      }, {
        title: '마스터',
        key: '30',
        children: [
          { title: '기초 문해력', key: '3001', isLeaf: true },
          { title: '기본 문해력', key: '' },
          { title: '창의논술', key: '3003' },
          { title: '사고력수학', key: '3004' },
          { title: '창의수학', key: '3005' },
        ]
      }, {
        title: '초등',
        key: '40',
        children: [
          { title: '3월', key: '4001', 
            children: [
              { title: '국어수학1-3월', key: '4001-1', }, 
              { title: '국어수학2-3월', key: '4001-2', }, 
              { title: '심화 문해력 논술1-3월', key: '4001-3', }, 
              { title: '심화 문해력 논술2-3월', key: '4001-4', }, 
              { title: '교과서 어휘 마침표1-3월', key: '4001-5', }, 
              { title: '교과서 어휘 마침표2-3월', key: '4001-6', }, 
              { title: '큐미르 신분1-3월', key: '4001-7', }, 
              { title: '큐미르 신문2-3월', key: '4001-8', }, 
            ]
          },
          { title: '4월', key: '4002' },
          { title: '5월', key: '4003' },
          { title: '6월', key: '4004' },
          { title: '7월', key: '4005' },
          { title: '8월', key: '4006' },
          { title: '9월', key: '4007' },
          { title: '10월', key: '4008' },
          { title: '11월', key: '4009' },
          { title: '12월', key: '4010' },
          { title: '1월', key: '4011' },
          { title: '2월', key: '4012' },
          { title: '초등 심화 수학', key: '4013' },
        ]
      }, {
        title: '연산',
        key: '50',
        children: [
        ]
      }, {
        title: '특별 프로그램',
        key: '60',
        children: [
          { title: '언어 톡톡', key: '6001' },
          { title: '두뇌 톡톡', key: '6002' },
          { title: '사회탐구', key: '6003' },
          { title: '역사탐구', key: '6004' },
        ]
      }, {
        title: '기타',
        key: '70',
        children: [
        ]
      }, 
  // {
  //   title: '전체',
  //   key: '00',
  //   children: [

      
  //   ]
  // }, 
]
export const basicData2 = [
  {
    cate1_key : '10',
    cate1_title : '베이직',
    cate2_key : '1001',
    cate2_title : '1호',
    book_key : '1001-1',
    book_title : '한글',
    isNew: true,
    isPin: true,
  },
  {
    cate1_key : '10',
    cate1_title : '베이직',
    cate2_key : '1001',
    cate2_title : '1호',
    book_key : '1001-2',
    book_title : '수학',
    isNew: true,
    isPin: true,
  },
  {
    cate1_key : '10',
    cate1_title : '베이직',
    cate2_key : '1001',
    cate2_title : '1호',
    book_key : '1001-3',
    book_title : '칠교',
    isNew: true,
    isPin: true,
  },
  {
    cate1_key : '10',
    cate1_title : '베이직',
    cate2_key : '1002',
    cate2_title : '2호',
    book_key : '1002',
    book_title : '2호',
    isNew: true,
    isPin: true,
  },
  {
    cate1_key : '10',
    cate1_title : '베이직',
    cate2_key : '1003',
    cate2_title : '3호',
    book_key : '1003',
    book_title : '3호',
    isNew: true,
    isPin: true,
  },
  {
    cate1_key : '10',
    cate1_title : '베이직',
    cate2_key : '1004',
    cate2_title : '4호',
    book_key : '1004',
    book_title : '4호',
    isNew: true,
    isPin: true,
  },
  {
    cate1_key : '10',
    cate1_title : '베이직',
    cate2_key : '1005',
    cate2_title : '5호',
    book_key : '1005',
    book_title : '5호',
    isNew: false,
    isPin: true,
  },
  {
    cate1_key : '20',
    cate1_title : '그로우',
    cate2_key : '2001',
    cate2_title : '한글',
    book_key : '2001',
    book_title : '한글',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '20',
    cate1_title : '그로우',
    cate2_key : '2002',
    cate2_title : '수학',
    book_key : '2002',
    book_title : '수학',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '20',
    cate1_title : '그로우',
    cate2_key : '2003',
    cate2_title : '칠교',
    book_key : '2003',
    book_title : '칠교',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '30',
    cate1_title : '마스터',
    cate2_key : '3001',
    cate2_title : '기초 문해력',
    book_key : '3001',
    book_title : '기초 문해력',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '30',
    cate1_title : '마스터',
    cate2_key : '3002',
    cate2_title : '기본 문해력',
    book_key : '3002',
    book_title : '기본 문해력',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4001',
    cate2_title : '3월',
    book_key : '4001-1',
    book_title : '국어수학1-3월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4001',
    cate2_title : '3월',
    book_key : '4001-2',
    book_title : '국어수학2-3월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4001',
    cate2_title : '3월',
    book_key : '4001-3',
    book_title : '심화 문해력 논술1-3월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4001',
    cate2_title : '3월',
    book_key : '4001-4',
    book_title : '심화 문해력 논술2-3월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4001',
    cate2_title : '3월',
    book_key : '4001-5',
    book_title : '교과서 어휘 마침표1-3월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4001',
    cate2_title : '3월',
    book_key : '4001-6',
    book_title : '교과서 어휘 마침표2-3월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4001',
    cate2_title : '3월',
    book_key : '4001-7',
    book_title : '큐미르 신분1-3월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4001',
    cate2_title : '3월',
    book_key : '4001-8',
    book_title : '큐미르 신문2-3월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4002',
    cate2_title : '4월',
    book_key : '4002',
    book_title : '4월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4003',
    cate2_title : '5월',
    book_key : '4003',
    book_title : '5월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4004',
    cate2_title : '6월',
    book_key : '4004',
    book_title : '6월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4005',
    cate2_title : '7월',
    book_key : '4005',
    book_title : '7월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4006',
    cate2_title : '8월',
    book_key : '4006',
    book_title : '8월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4007',
    cate2_title : '9월',
    book_key : '4007',
    book_title : '9월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4008',
    cate2_title : '10월',
    book_key : '4008',
    book_title : '10월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4009',
    cate2_title : '11월',
    book_key : '4009',
    book_title : '11월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4010',
    cate2_title : '12월',
    book_key : '4010',
    book_title : '12월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4011',
    cate2_title : '1월',
    book_key : '4011',
    book_title : '1월',
    isNew: false,
    isPin: false,
  },
  {
    cate1_key : '40',
    cate1_title : '초등',
    cate2_key : '4012',
    cate2_title : '2월',
    book_key : '4012',
    book_title : '2월',
    isNew: false,
    isPin: false,
  },


]


export const basicData = [
  {
    title: '1호',
    description: '베이직',
    isNew: true,
    isPin: true,
    group: '10',
    kind: '1001',
  }, {
    title: '2호',
    description: '베이직',
    isNew: true,
    isPin: true,
    group: '10',
    kind: '1002',
  }, {
    title: '3호',
    description: '베이직',
    isNew: true,
    isPin: true,
    group: '10',
    kind: '1003',
  }, {
    title: '한글',
    description: '그로우',
    isNew: true,
    isPin: false,
    group: '20',
    kind: '2001',
  }, {
    title: '수학',
    description: '그로우',
    isNew: false,
    isPin: false,
    group: '20',
    kind: '2002',
  }, {
    title: '기초 문해력',
    description: '마스터',
    isNew: false,
    isPin: false,
    group: '30',
    kind: '3001',
  }, {
    title: '국어수학1-3월',
    description: '초등',
    isNew: false,
    isPin: false,
    group: '40',
    kind: '4001',
  }, {
    title: '4월',
    description: '초등',
    isNew: false,
    isPin: false,
    group: '40',
    kind: '4002',
  }, {
    title: '국어수학2-3월',
    description: '초등',
    isNew: false,
    isPin: false,
    group: '40',
    kind: '4001',
  }, {
    title: '언어 톡톡',
    description: '특별 프로그램',
    isNew: false,
    isPin: false,
    group: '60',
    kind: '6001',
  }, 
]